export class C_Day {
  title: string;
  label: string;
  dayDifference: number;
}
